<template>
  <div class="single-action-checks">
    <!-- start:: Modal Header -->
    <div class="modal-header-group">
      <span class="top-header-title">{{
        modalHeaderTitle == "Temperature/Mask"
          ? $tc("signInOut.tempAndMask", 2)
          : modalHeaderTitle
      }}</span>
      <svg
        class="close-btn"
        @click="$bvModal.hide('checks')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <!-- end:: Modal Header -->

    <!-- start:: Temperature -->
    <template v-if="currentChecks.temperature">
      <!-- start:: Temperature unit -->
      <b-form-group
        :label="$t('common.temperatureUnit')"
        class="temperature-unit-label"
      >
        <b-form-radio-group
          class="custom-radios custom-activeRadio"
          :options="tempTypeOptions"
          v-model="$v.currentChecks.temperature.unitType.$model"
        />
      </b-form-group>
      <!-- end:: Temperature unit -->

      <!-- start:: Temperature value -->
      <b-form-group class="input-wrapper">
        <div class="temp-group d-flex align-items-baseline">
          <label class="label-style">{{ $t("common.temperature") }} </label>
          <span class="temperature-label ml-3">
            {{ currentChecks.temperature.currentValue }} °{{
              currentChecks.temperature.unitType == "c"
                ? $t("common.temperatureUnits.c").charAt(0).toUpperCase()
                : $t("common.temperatureUnits.f").charAt(0).toUpperCase()
            }}</span
          >
        </div>
        <!-- end:: Temperature value -->

        <div
          class="d-flex align-items-center"
          style="margin-inline-start: 13px"
        >
          <b-slider
            :min="currentChecks.temperature.unitType == 'c' ? 35 : 95"
            :max="currentChecks.temperature.unitType == 'c' ? 44 : 113"
            v-model="$v.currentChecks.temperature.currentValue.$model"
            :indicator="false"
            :tooltip="false"
            :step="0.1"
            size="is-medium"
            :rounded="true"
          ></b-slider>
          <div class="custom-line-inside"></div>
        </div>
      </b-form-group>
    </template>
    <!-- end:: Temperature -->

    <hr
      class="divider"
      v-if="currentChecks.mask && currentChecks.temperature"
    />
    <!-- start:: Mask -->
    <template v-if="currentChecks.mask">
      <b-form-group :label="$t('signInOut.hasAFaceMask')">
        <b-form-radio-group
          class="align-items-center input-wrapper custom-radios custom-activeRadio label-style"
          :options="maskOptions"
          v-model="$v.currentChecks.mask.currentValue.$model"
        >
        </b-form-radio-group>
      </b-form-group>
    </template>
    <!-- end:: Mask -->
    <button
      :disabled="
        !isTemperatureDirty &&
        !$v.currentChecks.temperature.unitType.$dirty &&
        !$v.currentChecks.mask.currentValue.$dirty
      "
      class="fillin-btn"
      @click="onChecksSubmit"
    >
      {{ currentChecks.isDirty ? $t("common.update").toUpperCase() : $t("signInOut.fillIn").toUpperCase() }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      temperatureOnMount: null,
      isTemperatureDirty: false,
      modelIsTouched: false,
      currentChecks: {},
      tempTypeOptions: [
        { text: `°${this.$t("common.temperatureUnits.f")}`, value: "f" },
        { text: `°${this.$t("common.temperatureUnits.c")}`, value: "c" },
      ],
      maskOptions: [
        { text: this.$t("common.yes"), value: true },
        { text: this.$t("common.no"), value: false },
      ],
    };
  },
  validations: {
    currentChecks: {
      mask: {
        currentValue: {},
      },
      temperature: {
        currentValue: {},
        unitType: {},
      },
    },
  },
  props: ["modalHeaderTitle"],
  methods: {
    onChecksSubmit() {
      if (this.currentChecks.allAction) {
        this.$emit(
          "allChecksAction",
          Object.assign(this.currentChecks, { isDirty: true, allAction: false })
        );
      } else {
        this.$emit(
          "checks",
          Object.assign(this.currentChecks, { isDirty: true })
        );
      }
      this.$bvModal.hide("checks");
    },
  },
  watch: {
    "currentChecks.temperature.currentValue"(newValue) {
      if (newValue != this.temperatureOnMount) this.isTemperatureDirty = true;
    },
    "currentChecks.temperature.unitType": {
      handler(val) {
        if (val == "c") this.currentChecks.temperature.currentValue = 37;
        else this.currentChecks.temperature.currentValue = 98.6;
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  beforeMount() {
    this.currentChecks = JSON.parse(JSON.stringify(this.getModalInfo));
    this.$v.currentChecks.$model = this.currentChecks; 
    this.temperatureOnMount = this.currentChecks.temperature.currentValue;
  },
};
</script>

<style lang="scss">
.single-action-checks {
  .temperature-unit-label {
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: start;
    color: #939393;
  }
  .temperature-unit-options-container {
    width: 150px;
    display: flex;
    justify-content: space-between;
  }

  .col-form-label {
    color: #939393;
    font-weight: 700;
    font-size: 16px;
    line-height: 19.2px;
  }

  //radio button label
  .custom-control-label {
    color: #606060;

    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    min-width: 90px;
    margin-top: 25px;
    margin-inline-end: -10px;
    padding-top: 2px;
    span {
      margin-inline-start: 10px;
    }
  }

  .custom-control-label::before {
    width: 20px;
    height: 20px;
    background: #c7c7c7 !important;
    //margin-top: 0px!important;
    border: 0 !important;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #103f5e !important;
    z-index: 1;
    border: 4px solid #c7c7c7 !important;
  }
  .custom-activeRadio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label
    span {
    color: #103f5e;
  }
  .custom-radios.custom-activeRadio {
    margin-top: -10px;
  }
  //Modal header
  .modal-header-group {
    width: 100%;
    text-align: center;
    margin: 15px auto 38px auto;
    span.top-header-title {
      font-style: normal;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
    }
  }

  .top-header-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  .label-style {
    margin: 40px 0 15px 0;

    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: start;
    color: #939393;
  }
  .temperature-label {
    color: #939393;
    background-color: #f2f2f2;
    padding: 15px;
    border-radius: 7px;

    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 46px;
    height: 44px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    margin-inline-start: 29px !important;
    color: rgba(96, 96, 96, 0.87);
    // opacity: 0.8;
  }
  .b-slider.is-medium .b-slider-track {
    height: 9px;
  }
  .b-slider-track {
    margin-inline-start: -10px;
    width: 388px;
    background-image: linear-gradient(
      89.98deg,
      #ffb545 3.49%,
      #fd7430 43.24%,
      #fc3205 97.7%
    ) !important;
  }
  .b-slider.is-primary .b-slider-fill {
    background-image: linear-gradient(
      89.98deg,
      #ffb545 3.49%,
      #fd7430 43.24%,
      #fc3205 97.7%
    ) !important;
  }
  .b-slider.is-medium .b-slider-thumb {
    width: 23px;
    height: 23px;
  }
  .b-slider.is-medium .b-slider-thumb::after {
    content: "''";
    opacity: 0.2;
    color: #000000;
    position: absolute;
    top: -4.5px;
    inset-inline-start: 4.5px;
    font-size: 28px;
    font-weight: 400;
  }
  .divider {
    width: 415px;
    margin: 40px 0 32px 0;
    border-top: 1px solid #000000;
    opacity: 8% !important;
  }
  .fillin-btn {
    border: 0;
    height: 44px;
    width: 415px;
    border-radius: 22px;
    background-color: #103f5e;

    font-size: 16px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #ffffff;
    margin-top: 20px;
    margin-bottom: 17px;
  }
  .fillin-btn:disabled {
    background-color: #96abb8;
  }
}
</style>
